import React, { Component } from 'react';
import { Table, Tooltip } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import './index.css';
const Checkbox = ({ type = 'checkbox', name, checked = false, onChange }) => (
    <div style={{ position: 'relative' }}>
        <input type={type} name={name} id={name} checked={checked} onChange={onChange} className="" />
    </div>
);

const months = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec'
}

const formatDate = (input) => {
    if (input !== null) {
        let datePart = input.match(/\d+/g),
            year = datePart[0],
            month = months[datePart[1]],
            day = datePart[2];

        return day + '-' + month + '-' + year;
    }
    return '';
};

class TableNew extends Component {

    constructor(props) {
        super(props);
        this.state = {

            checkedItems: new Map(),

            checkedItemFull: [],
            sendCheckData: [],
            tooltipOpen: {}

        };

        this.mainCheckbox = React.createRef();

        this.handleChange = this.handleChange.bind(this);



    }

    componentDidUpdate(prevProps, prevState) {
        this.handleDataChange(prevProps);
        this.handleCheckboxDataChange(prevProps);
        this.handleCheckedItemFullChange(prevProps, prevState);
    }



    handleDataChange(prevProps) {
        if (prevProps.data !== this.props.data && this.props.data === '') {
            this.resetCheckboxState();
        }
    }

    resetCheckboxState() {
        if (this.props.data.length === 0) {
            if (this.props.checkbox === "true") {
                this.mainCheckbox.current.checked = false;
            }
            this.setState({
                checkedItems: new Map(),
                checkedItemFull: []
            });
        }
    }

    handleCheckboxDataChange(prevProps) {
        if (prevProps.checkboxData !== this.props.checkboxData) {
            const updatedCheckedItems = new Map(this.state.checkedItems);
            this.props.checkboxData.forEach(val => {
                updatedCheckedItems.set(`${val.id}`, true);
            });
            this.setState({ checkedItems: updatedCheckedItems });
        }
    }

    handleCheckedItemFullChange(prevProps, prevState) {
        const shouldUpdate =
            prevState.checkedItemFull !== this.state.checkedItemFull ||
            (prevProps.data !== this.props.data && this.props.data !== '');

        if (shouldUpdate && this.props.checkbox === "true" && this.props.data !== '') {
            this.updateSendCheckData();
        }
    }

    updateSendCheckData() {
        const arrData = this.props.data.filter(val =>
            this.state.checkedItemFull.some(i =>
                val[this.props.CheckKey] == i[this.props.CheckKey] && i.value === true
            )
        );

        this.setState({ sendCheckData: arrData }, () => {
            if (this.props.handleExpiryCallBack) {
                this.props.handleExpiryCallBack(this.state.sendCheckData);
            }
            this.props.getData(this.state.sendCheckData);
        });
    }


    handleChange(e, data, type) {
        if (type === 'single') {
            this.handleSingleChange(e);
        } else if (type === 'all') {
            this.handleAllChange(e);
        }
    }

    handleSingleChange(e) {
        const item = e.target.name;
        const isChecked = e.target.checked;

        this.setState(prevState => ({
            checkedItems: prevState.checkedItems.set(item, isChecked)
        }), () => {
            this.updateCheckedItemFull();
            this.updateMainCheckbox();
        });
    }

    handleAllChange(e) {
        const isChecked = e.target.checked;
        const updatedItems = new Map(
            this.props.data.map(item => [`${item[this.props.CheckKey]}`, isChecked])
        );

        this.setState({
            checkedItems: updatedItems
        }, this.updateCheckedItemFull);
    }

    updateCheckedItemFull() {
        const arrChecked = Array.from(this.state.checkedItems, ([key, value]) => ({
            [this.props.CheckKey]: key,
            value: value
        }));

        this.setState({ checkedItemFull: arrChecked });
    }

    updateMainCheckbox() {
        const allChecked = Array.from(this.state.checkedItems.values()).every(Boolean);
        const allItemsPresent = this.state.checkedItems.size === this.props.data.length;

        this.mainCheckbox.current.checked = allChecked && allItemsPresent;
    }

    rowClickable(data) {
        this.props.rowClickable.func(data)
    }

    toggleTooltip = (id) => {
        this.setState(prevState => ({
            tooltipOpen: {
                ...prevState.tooltipOpen,
                [id]: !prevState.tooltipOpen[id]
            }
        }));
    }





    render() {

        const that = this;
        const { columns, data, showSlNo, checkbox, modalOpener, sortType, detailsModal, checkboxData } = this.props;



        return (
            <div style={{ overflowX: 'auto' }}>
                <Table bordered className="Table-CustomTable animation-fade-in">
                    <thead className="text-center">
                        <tr>
                            {
                                showSlNo === "true" &&
                                <th>#</th>
                            }
                            {
                                checkbox === "true" &&
                                <th>
                                    {/* all select input box. do not remove Label for UI*/}
                                    <div style={{ position: 'relative' }}>

                                        <input type="checkbox" id="mainCheckbox" ref={this.mainCheckbox} onChange={(e) => this.handleChange(e, data, 'all')} className="" />
                                    </div>
                                </th>
                            }
                            {/* map column heading */}
                            {columns.map(function (column, index) {
                                return <th
                                    className={data.length !== 1 && detailsModal === 'true' ? "text-muted quattrocentosans extraClass bold display-hover cursor-pointer animation-fade-in" : "text-muted quattrocentosans bold display-hover animation-fade-in"}
                                    key={index}
                                    onClick={() => { that.props.sortBy(column.key) }}

                                >{
                                        column.name !== 'REMAINDER' &&
                                        column.name
                                    }&nbsp;
                                    {
                                        column.name === 'REMAINDER' &&
                                        <i className=" fas fa-bell"></i>
                                    }&nbsp;

                                    {
                                        (sortType === false && column.sort === true && data.length > 1) &&
                                        <i className="fas fa-sort-up custom-sort "></i>
                                    }

                                    {
                                        (sortType === true && column.sort === true && data.length > 1) &&
                                        <i className="fas fa-sort-down custom-sort "></i>
                                    }
                                    {
                                        (column.sort === true && data.length > 1) &&
                                        <i className="fas fa-sort custom-sort-display "></i>
                                    }

                                </th>;
                            })}
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {/* map each row as per the length of the array data prop */}
                        {

                            this.props.repondentTable !== undefined && this.props.instructionState !== undefined &&
                                this.props.instructionState &&
                                this.props.repondentTable ?
                                <tr>
                                    <td>Email Address</td>
                                    <td>Relation</td>
                                    <td style={{ textAlign: 'left', color: 'rgb(86, 86, 86)' }}>
                                        <div>
                                            <div style={{ display: 'flex' }}>
                                                <div class="progressTab">
                                                    <div class="progressTabRed"></div>
                                                    <div class="progressTabWhite progressTabBorderRed"></div>
                                                    <div class="progressTabWhite progressTabBorderRed"></div>
                                                </div>
                                                <p>Yet to start</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ textAlign: 'left', color: 'rgb(86, 86, 86)' }}>
                                        <span style={{ cursor: 'pointer', textDecoration: 'underline', display: 'flex', justifyContent: 'space-around' }}>
                                            <i class="fas fa-pencil-alt "></i>
                                            <i class="fas fa-times "></i>
                                        </span>
                                    </td>
                                    <td style={{ textAlign: 'left', color: 'rgb(86, 86, 86)' }}>
                                        <span style={{ cursor: 'pointer', textDecoration: 'underline', display: 'flex', justifyContent: 'space-around' }}>
                                            <i class="fas fa-paper-plane paper-plane "></i>
                                        </span>
                                    </td>
                                </tr>
                                :
                                null
                        }
                        {data.length > 0 &&
                            data.map(function (seller, i) {
                                return <tr key={i} style={that.props.noPointerClass !== undefined ? { cursor: 'default' } : { cursor: 'pointer' }} onDoubleClick={checkbox === "true" ? () => that.handleChange({
                                    target: {
                                        checked: !that.state.checkedItems.get(`${seller[that.props.CheckKey]}`),
                                        name: `${seller[that.props.CheckKey]}`
                                    }
                                }, seller, 'single') : null} className={that.props.rowClickable !== undefined ? seller['assessment_status__status_name'] !== undefined ? seller['assessment_status__status_name'] === 'Completed' ? 'disableButton animation-fade-in' : 'animation-fade-in' : 'rowClickable animation-fade-in' : 'animation-fade-in'} onClick={that.props.rowClickable !== undefined ? () => that.rowClickable(seller) : () => { }}>
                                    {
                                        showSlNo === "true" &&
                                        <td>{i + 1}</td>
                                    }
                                    {
                                        checkbox === "true" &&
                                        <td>
                                            {/* Single select input box. do not remove Label for UI*/}
                                            <Checkbox name={`${seller[that.props.CheckKey]}`} checked={that.state.checkedItems.get(`${seller[that.props.CheckKey]}`)} onChange={(e) => that.handleChange(e, seller, 'single')} />
                                        </td>
                                    }
                                    {/* Still in loop. Loop again for Cells in each row as the length of column length. Check each key and type from column for the corresponding data prop */}
                                    {columns.map(function (column, index) {
                                        return <td style={{ textAlign: column.textAlign !== undefined ? column.textAlign : that.props.textAlign !== undefined ? that.props.textAlign : 'left', color: '#565656' }}
                                            className="animation-fade-in"
                                            key={index}>
                                            {
                                                (column.type === 'text' || column.type === 'button') &&
                                                    seller[column.key] === null &&

                                                    column.key === 'user_access__is_primary_admin' ?
                                                    <p style={{ display: 'none' }}></p>
                                                    :
                                                    seller[column.key] === null &&
                                                    <p style={{ textAlign: 'left' }}>-</p>
                                            }
                                            {
                                                column.link !== '' &&
                                                <Link
                                                    className="text-dark"
                                                    onClick={() => {
                                                        column.storeInLocal !== undefined &&
                                                            column.storeInLocal.status &&
                                                            localStorage.setItem(column.storeInLocal.name, JSON.stringify(seller))
                                                    }}
                                                    to={{
                                                        pathname: column.link + `${column.linkIdKey !== undefined ? seller[column.linkIdKey] : seller.id}`,
                                                        state: { sellerData: seller }
                                                    }}>
                                                    {seller[column.key]}
                                                </Link>
                                            }

                                            {
                                                (column.type === 'icon' && column.content === 'add') &&
                                                <i className="fa fa-plus-circle text-danger">
                                                </i>
                                            }
                                            {
                                                (column.type === 'icon' && column.content === 'remove') &&
                                                !seller.user_access__is_primary_admin &&
                                                <i className="fa fa-minus-circle text-danger" style={{ cursor: 'pointer' }} onClick={() => that.props.iconFunc.remove(column.type, seller)}>
                                                </i>
                                            }
                                            {
                                                (column.type === 'icon' && column.content === 'delete') &&
                                                <i className="fa fa-trash text-danger" style={{ cursor: 'pointer' }} onClick={() => that.props.iconFunc.delete(column.type, seller)}>
                                                </i>
                                            }
                                            {
                                                (seller[column.key] !== undefined && column.key !== 'bulk_download_permission_given') ?
                                                    (seller[column.key] === false || seller[column.key] === null) &&
                                                    (column.type === 'button') &&
                                                    <button className="btn btn-red sm--size" onClick={() => that.props.buttonFunc(column, seller)}>
                                                        {column.content}
                                                    </button>
                                                    :
                                                    column.key === 'bulk_download_permission_given' ?
                                                        <button className="btn btn-red sm--size" onClick={() => that.props.buttonFunc(column, seller)}>
                                                            {seller[column.key] ? 'Deny Bulk Download Permissions' : 'Allow Bulk Download Permissions'}
                                                        </button>
                                                        :
                                                        (column.type === 'button') &&
                                                        <button className="btn btn-red sm--size" onClick={() => that.props.buttonFunc(column, seller)}>
                                                            {column.content}
                                                        </button>
                                            }

                                            {
                                                (column.type === 'tickmark') &&
                                                seller[column.key] === true &&
                                                <i className="fas fa-check" style={{ textAlign: 'center', width: '100%' }}></i>
                                            }

                                            {
                                                (column.type === 'tickmark') &&
                                                seller[column.key] === false &&
                                                <i className="fas fa-times" style={{ textAlign: 'center', width: '100%' }}></i>
                                            }

                                            {
                                                seller[column.key] !== undefined ?
                                                    seller[column.key] === true && column.key !== 'bulk_download_permission_given' &&
                                                    (column.type === 'button') &&
                                                    <i className="fas fa-trophy text-green"></i>
                                                    :
                                                    null
                                            }

                                            {
                                                // logo images LOI and VVI or Assessment data.
                                                (column.type === 'logoText' && seller[column.key] !== null) &&
                                                <div>
                                                    {that.props.tableType === 'ACTIVE PARTICIPANTS' ? (
                                                        // Render content for ACTIVE PARTICIPANTS
                                                        typeof seller[column.key] === 'string' ? (
                                                            <React.Fragment>
                                                                <img
                                                                    style={{ boxShadow: '0 0 3px 2px #0000008a', borderRadius: 16, padding: 2 }}
                                                                    src={localStorage.getItem('baseLink') + `/media/` + seller.user_assessment__instrument__instrument_image}
                                                                    width={30}
                                                                />
                                                            </React.Fragment>
                                                        ) : typeof seller[column.key] === 'object' && Array.isArray(seller[column.key]) ? (
                                                            seller[column.key].map((val, key) => {
                                                                const tooltipId = `assessment-${val.id}`;
                                                                const userType = localStorage.getItem("usertype");
                                                                const isOrganisationAdmin = userType && userType.split(',').includes("organisation_admin");
                                                                const isClickable = val.is_self_assessment_completed && !isOrganisationAdmin;

                                                                return (
                                                                    <React.Fragment key={key}>
                                                                        <div
                                                                            id={tooltipId}
                                                                            style={{
                                                                                display: 'inline-block',
                                                                                border: '1px solid rgb(233, 233, 233)',
                                                                                marginRight: '0.3rem',
                                                                                padding: '0.5rem',
                                                                                borderRadius: '4px',
                                                                                opacity: val.is_self_assessment_completed ? 1 : 0.6
                                                                            }}
                                                                        >
                                                                            {/* Assessment Section */}
                                                                            <div
                                                                                style={{
                                                                                    cursor: isClickable ? 'pointer' : 'default',
                                                                                    padding: '0.3rem',
                                                                                    backgroundColor: isClickable ? '#f8f9fa' : 'transparent',
                                                                                    borderRadius: '4px',
                                                                                    transition: 'background-color 0.2s'
                                                                                }}
                                                                                onClick={() => {
                                                                                    if (isClickable) {
                                                                                        const batchValue = val.batch === null ? 'unalloted' : val.batch;
                                                                                        const url = `/admin/app/assessment-summary/assessments/${val.id}?organisation=${val.organisation}&batch=${batchValue}`;
                                                                                        window.open(url, '_blank');
                                                                                    }
                                                                                }}
                                                                                onMouseOver={(e) => {
                                                                                    if (isClickable) {
                                                                                        e.currentTarget.style.backgroundColor = '#f0f0f0';
                                                                                    }
                                                                                }}
                                                                                onMouseOut={(e) => {
                                                                                    if (isClickable) {
                                                                                        e.currentTarget.style.backgroundColor = '#f8f9fa';
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <span>
                                                                                    <img
                                                                                        src={localStorage.getItem('baseLink') + `/media/` + val.instrument__instrument_image}
                                                                                        style={{ height: '1.5rem', width: '1.5rem', marginRight: '0.5rem' }}
                                                                                        alt={val.instrument__instrument_name}
                                                                                    />
                                                                                </span>
                                                                                <span style={{ display: 'inline-block', verticalAlign: 'middle', fontSize: '12px' }}>
                                                                                    <div style={{ fontWeight: '500' }}>{val.instrument__instrument_name}</div>
                                                                                    <div style={{ color: '#666' }}>{val.assessment_year}</div>
                                                                                </span>
                                                                            </div>

                                                                            {/* Batch Section - Now handles both allocated and unalloted cases */}
                                                                            <div
                                                                                style={{
                                                                                    marginTop: '0.4rem',
                                                                                    paddingTop: '0.4rem',
                                                                                    borderTop: '1px dashed #e0e0e0',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '0.3rem'
                                                                                }}
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        padding: '0.2rem 0.5rem',
                                                                                        backgroundColor: val.batch__batch_name ? '#f0f7ff' : '#fff0f0',
                                                                                        color: val.batch__batch_name ? '#0066cc' : '#cc0000',
                                                                                        fontSize: '11px',
                                                                                        borderRadius: '12px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        transition: 'background-color 0.2s'
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        const orgId = val.organisation;
                                                                                        const url = val.batch__batch_name
                                                                                            ? `/admin/app/organisation/${orgId}/manageBatches/${val.batch}`
                                                                                            : `/admin/app/organisation/${orgId}/manageBatches`;
                                                                                        window.open(url, '_blank');
                                                                                    }}
                                                                                    onMouseOver={(e) => {
                                                                                        e.currentTarget.style.backgroundColor = val.batch__batch_name ? '#e6f0ff' : '#ffe6e6';
                                                                                    }}
                                                                                    onMouseOut={(e) => {
                                                                                        e.currentTarget.style.backgroundColor = val.batch__batch_name ? '#f0f7ff' : '#fff0f0';
                                                                                    }}
                                                                                >
                                                                                    <i className="fas fa-layer-group" style={{ fontSize: '10px', marginRight: '4px' }}></i>
                                                                                    {val.batch__batch_name || 'UNALLOTED'}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {!val.is_self_assessment_completed && (
                                                                            <Tooltip
                                                                                placement="top"
                                                                                isOpen={that.state.tooltipOpen[tooltipId]}
                                                                                target={tooltipId}
                                                                                toggle={() => that.toggleTooltip(tooltipId)}
                                                                            >
                                                                                Incomplete
                                                                            </Tooltip>
                                                                        )}
                                                                    </React.Fragment>
                                                                );
                                                            })
                                                        ) : (
                                                            <div style={{ display: 'inline-block', border: '1px solid rgb(233, 233, 233)', marginRight: '0.3rem', fontSize: 11, padding: '0.3rem' }}>
                                                                <span>
                                                                    <img src={localStorage.getItem('baseLink') + `/media/` + seller[column.key].instrument__instrument_image} style={{ height: '1.5rem', width: '1.5rem', marginRight: '0.5rem' }} />
                                                                </span>
                                                                <span>{seller[column.key].assessment_year}</span>
                                                            </div>
                                                        )
                                                    ) : (
                                                        // Render content for other cases (original code)
                                                        typeof seller[column.key] === 'string' ? (
                                                            <React.Fragment>
                                                                <img style={{ boxShadow: '0 0 3px 2px #0000008a', borderRadius: 16, padding: 2 }} src={localStorage.getItem('baseLink') + `/media/` + seller.user_assessment__instrument__instrument_image} width={30} />
                                                            </React.Fragment>
                                                        ) : typeof seller[column.key] === 'object' && Array.isArray(seller[column.key]) ? (
                                                            seller[column.key].map((val, key) => (
                                                                <React.Fragment key={key}>
                                                                    <div style={{ display: 'inline-block', border: '1px solid rgb(233, 233, 233)', marginRight: '0.3rem', fontSize: 11, padding: '0.3rem' }}>
                                                                        <span>
                                                                            {val.instrument__instrument_image && (
                                                                                <img src={localStorage.getItem('baseLink') + `/media/` + val.instrument__instrument_image} style={{ height: '1.5rem', width: '1.5rem', marginRight: '0.5rem' }} />
                                                                            )}
                                                                        </span>
                                                                        {val.assessment_year && (
                                                                            <span>{val.assessment_year}</span>
                                                                        )}
                                                                    </div>
                                                                    {val.instrument__instrument_name && !val.assessment_year && (
                                                                        <span className="h6">{val.instrument__instrument_name}</span>
                                                                    )}
                                                                </React.Fragment>
                                                            ))
                                                        ) : (
                                                            <div style={{ display: 'inline-block', border: '1px solid rgb(233, 233, 233)', marginRight: '0.3rem', fontSize: 11, padding: '0.3rem' }}>
                                                                <span>
                                                                    <img src={localStorage.getItem('baseLink') + `/media/` + seller[column.key].instrument__instrument_image} style={{ height: '1.5rem', width: '1.5rem', marginRight: '0.5rem' }} />
                                                                </span>
                                                                <span>{seller[column.key].assessment_year}</span>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            }




                                            {
                                                //3 DOT Progress bar
                                                (column.type === 'progressBubble') &&
                                                <div>
                                                    <div style={{ display: 'flex' }}>
                                                        <div className="progressTab">
                                                            <div className={seller[column.key] === 'Completed' ? "progressTabGreen" : seller[column.key] === 'In progress' ? 'progressTabYellow' : 'progressTabRed'} >

                                                            </div>
                                                            <div className={seller[column.key] === 'Completed' ? "progressTabGreen" : seller[column.key] === 'In progress' ? 'progressTabYellow' : 'progressTabWhite progressTabBorderRed'} >

                                                            </div>
                                                            <div className={seller[column.key] === 'Completed' ? "progressTabGreen" : seller[column.key] === 'In progress' ? 'progressTabWhite progressTabBorderYellow' : 'progressTabWhite progressTabBorderRed'} >

                                                            </div>
                                                        </div>
                                                        <p>{seller[column.key] !== null ? seller[column.key] : 'null'}</p>
                                                    </div>
                                                </div>
                                            }

                                            {
                                                //modal opener for underline text
                                                (column.type === 'modalOpeners' && column.modalStyle === 'link') &&
                                                seller.instrument__is_custom_report_enabled !== undefined &&
                                                seller.instrument__is_custom_report_enabled === true &&
                                                <span style={{ cursor: 'pointer', color: 'rgb(26, 163, 136)', textDecoration: 'underline' }} onClick={() => column.modalOpener(seller)}>
                                                    {
                                                        seller[column.key] !== false ? 'Default' : 'Custom'
                                                    }
                                                </span>
                                            }


                                            {
                                                //modal opener for icons
                                                (column.type === 'modalOpeners' && column.modalStyle !== 'link') &&
                                                <span style={{ cursor: 'pointer', textDecoration: 'underline', display: 'flex', justifyContent: 'space-around' }}>
                                                    {
                                                        column.modalData.map(val => {
                                                            if (val.modalStyle === 'icon') {
                                                                return <i key={val.id} className={seller[val.disability] && val.iconClass !== 'fas fa-paper-plane paper-plane' ? `${val.iconClass} disableButton` : seller[val.disabledKey] === val.disabledWhenBool ? `${val.iconClass} disableButton ` : seller[val.disability2] !== 'Yet to start' && !val.disabledDisability2 ? `${val.iconClass} disableButton ` : `${val.iconClass} `} onClick={() => val.modalOpenerFunc({ buttonType: val.funcType, rowData: seller })}></i>
                                                            }
                                                        })
                                                    }
                                                </span>
                                            }

                                            {
                                                column.type === 'extreame_response' &&
                                                <p>{seller[column.key] === 0 ? 'Normal' : seller[column.key] === 1 ? 'Lowest Extreme' : 'Highest Extreme'}</p>
                                            }

                                            {
                                                (column.type === 'progressTab') &&
                                                <div style={{ display: 'flex' }}>
                                                    <div className="progressTab">
                                                        <div className="progressTabGreen">

                                                        </div>
                                                        <div className="progressTabGreen">

                                                        </div>
                                                        <div className="progressTabGreen">

                                                        </div>
                                                    </div>
                                                    <p>{seller[column.key]}</p>
                                                </div>
                                            }

                                            {
                                                column.type === 'date' &&
                                                formatDate(seller[column.key])
                                            }

                                            {
                                                //default text
                                                column.link === '' &&
                                                    (column.type) !== 'date' &&
                                                    column.type !== 'extreame_response' &&
                                                    (column.type !== 'progressTab') ?
                                                    (column.link === '' && (column.type === undefined || column.type === 'text')) &&
                                                        seller[column.key] == null || column.type === 'logoText' ?
                                                        ''
                                                        :
                                                        column.type !== 'progressBubble' ?
                                                            seller.instrument__instrument_name !== undefined ?
                                                                seller.instrument__is_development_plan_enabled === false ?
                                                                    column.key !== 'dev_plan' && column.key !== 'default_report' &&
                                                                    seller[column.key]
                                                                    :
                                                                    column.key !== 'dev_plan' ?
                                                                        seller[column.key]
                                                                        :
                                                                        seller[column.key] === false ?
                                                                            'INTEGRATED'
                                                                            :
                                                                            'STAND-ALONE'
                                                                :
                                                                seller[column.key]
                                                            :
                                                            ``
                                                    :
                                                    null
                                            }

                                        </td>;
                                    })}
                                </tr>
                            })}
                        {
                            data.length == 0 ?
                                checkbox === 'true' && showSlNo === 'true' ?
                                    <tr>
                                        <td colSpan={columns.length + 2} className="text-center">No data to display</td>
                                    </tr>
                                    :
                                    <tr>
                                        <td colSpan={columns.length + 1} className="text-center">No data to display</td>
                                    </tr>
                                :
                                null
                        }
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default withRouter(TableNew);


// WEBPACK FOOTER //
// ./src/_components/common/CustomTableNew/index.jsx